import { createSelector } from 'reselect';
export const routingSelector = state => state.routing;
export const routingLocationStateSelector = createSelector(routingSelector, routing => routing.locationState);